import { useCallback, useState } from 'react'
import RecordRTC from 'recordrtc'

export function useAudioRecorder(duration: number = 10) {
  const [recorder, setRecorder] = useState<RecordRTC | null>(null)
  const [isRecording, setIsRecording] = useState<boolean>(false)

  const handleRecordingStopped = (recorder: RecordRTC) => {
    const blob = recorder.getBlob()
    const fileName = encodeURIComponent('audio-' + new Date().getTime() + '.mp3')

    return { blob, name: fileName }
  }

  const startRecording = useCallback((stream: MediaStream, cb: (data: { blob: Blob, name: string }) => void) => {
    // It means recording is already started or it is already recording something
    if (recorder) return

    let audioRecorder = new RecordRTC(stream, {
      type: 'audio',
      mimeType: 'audio/ogg',
      // disable logs
      disableLogs: true,
    })
    audioRecorder.startRecording()
    audioRecorder.setRecordingDuration(duration * 1000, () => {
      cb(handleRecordingStopped(audioRecorder))
      setRecorder(null)
      setIsRecording(false)
    })
    setIsRecording(true)
    setRecorder(audioRecorder)
  }, [duration, recorder])

  const stopRecording = useCallback((cb: (data: { blob: Blob, name: string }) => void) => {
    if (!recorder) return

    recorder.stopRecording(() => {
      setIsRecording(false)
      setRecorder(null)
      cb(handleRecordingStopped(recorder))
    })
  }, [recorder])

  return {
    isRecording,
    startRecording,
    stopRecording
  }
}

export default useAudioRecorder
